import { LoadingOutlined } from '@ant-design/icons';
import { Flex, Spin, Table, TableProps, Button } from "antd";
import Card from "antd/es/card/Card";
import { LoaderSpinner } from "../../components/common/Loader";
import React, { useEffect, useState } from "react";
import { getClientInvoiceCorrectionAuditHistory, getCorrectionTrips } from "../../service/httpsCalls";
import "./billing.scss";
import { createTableConfig } from "./tableConfig";

const ReviewCorrection = ({ invoiceInfo, parentCallback }) => {
    const [tableHeight, setTableHeight] = React.useState(300); // Adjust as needed
    const client = invoiceInfo.clientId.toString();
    const invoiceNum = invoiceInfo.invoiceNumber;
    const [records, setRecords] = useState<any>([]);
    const [tableColumns, setTableColumns] = useState([]);
    const [filteredRowCount, setFilteredRowCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [expandAllLoading, setExpandAllLoading] = useState(false);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [expandedContent, setExpandedContent] = useState({});
    const [loadingRows, setLoadingRows] = useState({});
    const [menuVisible, setMenuVisible] = useState(false);
    const [position, setPosition] = useState({
        x: 0,
        y: 0
    });
    const tableChanges: TableProps<any>['onChange'] = (pagination, filters, sorter, extra) => {
        if (extra.action == 'filter') {
            setFilteredRowCount(extra.currentDataSource.length);
            return;
        }
        if (extra.action == 'sort') {
            return;
        }
    };
    useEffect(() => {
        handleSearch();
    }, []);

    useEffect(() => {
        if (records?.length && tableHeight == 300) {
            updateTableHeight();
        }
    }, [records])

    const updateTableHeight = () => {
        const updateHeight = () => {
            const container = document.getElementById("table-container");
            if (container) {
                const header = document.getElementById("table-container")?.getElementsByClassName("ant-table-header")[0].clientHeight ?? 10;
                setTableHeight(container.clientHeight - header); // Ensure it fits inside
            }
        };

        window.addEventListener("resize", updateHeight);
        updateHeight(); // Initial height calculation

        return () => window.removeEventListener("resize", updateHeight);
    }

    function handleSearch() {

        setLoading(true);
        if (!(client && invoiceNum)) {
            setLoading(false);
            return;
        }

        setFilteredRowCount(0);
        getCorrectionTrips({
            clientId: client,
            id: invoiceInfo.id,
            searchByType: 4,// get Trips with Correction list without filter 
            tripCsv: invoiceNum,
            invoiceType: invoiceInfo.invoiceType
        }, (res) => {
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!';
                setLoading(false);
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                })
                setRecords([]);

            } else {
                setLoading(false);
                setRecords(res.items);

                if (res.columnConfigs && !tableColumns.length) {
                    let cols = createTableConfig(res.columnConfigs);
                    setTableColumns(cols);
                }

                parentCallback({
                    updateDrawerConfig: true,
                    width: res.items?.length > 0 ? 1250 : 1000
                });
            }
        })

    };

    function fetchExpandContent(record, rowKey) {

        setLoadingRows((prev) => ({ ...prev, [rowKey]: true }));
        getClientInvoiceCorrectionAuditHistory({
            clientId: client,
            clientInvoiceSId: invoiceInfo.id,
            triplegId: record.tripLegId // or record.uniqueID or appropriate field
        }, (res) => {
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!';
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                })
                setExpandedContent((prev) => ({ ...prev, [rowKey]: null }));
                setLoadingRows((prev) => ({ ...prev, [rowKey]: false }));
            } else {
                const cols = createTableConfig(res.columnConfigs) || [];
                setExpandedContent((prev) => ({
                    ...prev,
                    [rowKey]: (
                        loadNestedTable(rowKey, res.items, cols)
                    )
                }));

                setLoadingRows((prev) => ({ ...prev, [rowKey]: false }));
            }

        });

    };
    function loadNestedTable(rowKey: any, items: any, cols: any) {

        return <Card id={`expand-container-${rowKey}`} styles={{ body: { padding: '2px', height: "100%", backgroundColor: "#EFF1F5" } }}>
            <div style={{ overflow: "hidden", height: "100%" }}>
                <Table
                    id={rowKey}
                    dataSource={items || []}
                    columns={cols}
                    rowKey="sId"
                    pagination={false}
                    virtual={true}
                    scroll={{ y: 800 }}
                    size="small" />
            </div>
        </Card>;
    };

    const handleExpandAll = async () => {
        setExpandAllLoading(true);

        await getClientInvoiceCorrectionAuditHistory({
            clientId: client,
            clientInvoiceSId: invoiceInfo.id,
            triplegId: 0
        }, (res) => {
            if (res?.hasError) {
                setExpandAllLoading(false);
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!';
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                })

            } else {
                const cols = createTableConfig(res.columnConfigs) || [];
                for (const row of records) {
                    const rowKey = row.uniqueID;
                    if (!expandedContent[rowKey]) {
                        const items = res.items.filter(item => item.uniqueID === rowKey);
                        setExpandedContent((prev) => ({
                            ...prev,
                            [rowKey]: (
                                loadNestedTable(rowKey, items, cols)
                            )
                        }));
                    }
                    // Add row key to expandedRowKeys (only if not already added)
                    setExpandedRowKeys(prev => {
                        if (!prev.includes(rowKey)) return [...prev, rowKey];
                        return prev;
                    });
                }
            }
        });
        setExpandAllLoading(false);

    };


    function handleCollapseAll() {
        setExpandedRowKeys([]);

    };

    function expandedRowRender(record) {
        const content = expandedContent[record.uniqueID];
        const loading = loadingRows[record.uniqueID];

        if (loading) {
            return (
                <div style={{ textAlign: "center", padding: 20 }}>
                    <Spin
                        indicator={
                            <LoadingOutlined style={{ fontSize: 24, color: "#1677ff" }} spin />
                        }
                    />
                </div>
            );
        }

        return content || null;
    };

    return (
        <>
            <div className={records?.length > 0 ? 'parentDiv' : ''}>
                <div style={{ width: '100%' }}>

                    <Card styles={{ body: { padding: '15px', paddingTop: '10px', height: "auto", maxHeight: records?.length > 0 ? "calc(100vh - 135px)" : undefined } }} loading={loading}>
                        {
                            records?.length > 0 &&
                            <Flex justify="space-between" align="center" style={{ paddingBottom: "5px", paddingTop: "0", background: '#fff' }}>

                                {/* Left side content */}
                                <div style={{ background: '#e6f4ff', padding: '0px 5px', fontWeight: 500 }}>
                                    <span style={{ marginRight: '5px', marginLeft: '5px', paddingRight: "5px" }}>
                                        Total: {records.length}
                                    </span>

                                    {
                                        filteredRowCount > 0 && filteredRowCount !== records.length &&
                                        <span style={{ marginRight: '5px', borderLeft: "1px solid #d4d2d2", paddingLeft: "5px" }}>
                                            Filtered: {filteredRowCount}
                                        </span>
                                    }
                                </div>

                                {/* Right side buttons */}
                                <div>
                                    <Button onClick={handleExpandAll} loading={expandAllLoading} type="primary" style={{ marginLeft: '5px' }}>Expand All</Button>
                                    <Button onClick={handleCollapseAll} style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', marginLeft: '5px', color: 'rgba(0, 0, 0, 0.88)' }} type="primary">Collapse All</Button>
                                </div>

                            </Flex>
                        }
                        <Spin spinning={expandAllLoading} indicator={
                            <LoadingOutlined style={{ fontSize: 24, color: "#1677ff" }} spin />
                        }>
                            {
                                records?.length > 0 &&
                                <div id="table-container" style={{ height: "calc(100vh - 215px)", width: "100%", overflowY: "hidden", overflowX: "auto" }} >
                                    <Table
                                        scroll={{
                                            y: tableHeight,
                                            x: tableColumns.reduce((acc, col: any) => acc + (col.width || 150), 0) + 25,
                                        }}
                                        key="reviewCorrectionTable"
                                        virtual={true}
                                        dataSource={records}
                                        pagination={false}
                                        columns={tableColumns}
                                        onChange={tableChanges}
                                        rowKey="uniqueID"
                                        size="small"
                                        expandable={{
                                            expandedRowRender,
                                            expandedRowKeys,
                                            onExpand: (expanded, record) => {
                                                const rowKey = record.uniqueID;
                                                if (expanded) {
                                                    if (!expandedContent[rowKey]) {
                                                        fetchExpandContent(record, rowKey);
                                                    }
                                                    // Add row key to expandedRowKeys (only if not already added)
                                                    setExpandedRowKeys(prev => {
                                                        if (!prev.includes(rowKey)) return [...prev, rowKey];
                                                        return prev;
                                                    });
                                                }
                                                else {
                                                    setExpandedRowKeys((prev) => prev.filter((k) => k !== rowKey));
                                                }
                                            },
                                        }}
                                        onHeaderRow={(columns, index) => {
                                            return {
                                                onContextMenu: (event) => {
                                                    event.preventDefault();
                                                    if (!menuVisible) {
                                                        document.addEventListener(`click`, function onClickOutside() {
                                                            setMenuVisible(false);
                                                            document.removeEventListener(`click`, onClickOutside);
                                                        });
                                                    }
                                                    setMenuVisible(true);
                                                    setPosition({ x: event.clientX, y: event.clientY });
                                                }
                                            };
                                        }}
                                    />
                                </div>
                            }
                        </Spin>
                    </Card>
                </div>

            </div >
        </>
    );
};

export default ReviewCorrection;